/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
export const CW_ENCRYPT_USING_MASTER_KEYPAIR = 'CW_ENCRYPT_USING_MASTER_KEYPAIR';
export const CW_DECRYPT_USING_MASTER_KEYPAIR = 'CW_DECRYPT_USING_MASTER_KEYPAIR';
export const CW_CONVERT_INPUT = 'CW_CONVERT_INPUT';
export const CW_DECRYPT_CREDENTIALS = 'CW_DECRYPT_CREDENTIALS';
export const CW_DECRYPT_DASHBOARD = 'CW_DECRYPT_DASHBOARD';
export const CW_DECRYPT_MASTER_SECRET_KEY = 'CW_DECRYPT_MASTER_SECRET_KEY';
export const CW_DECRYPT_WITH_EXTERNAL_KEYS = 'CW_DECRYPT_WITH_EXTERNAL_KEYS';
export const CW_DERIVE_PUBLIC_KEY_FROM_SECRET = 'CW_DERIVE_PUBLIC_KEY_FROM_SECRET';
export const CW_ENCRYPT_CREDENTIALS = 'CW_ENCRYPT_CREDENTIALS';
export const CW_ENCRYPT_MASTER_SECRET_KEY = 'CW_ENCRYPT_MASTER_SECRET_KEY';
export const CW_ENCRYPT_WITH_EXTERNAL_KEY = 'CW_ENCRYPT_WITH_EXTERNAL_KEY';
export const CW_EXTRACT_MASTER_KEYS = 'CW_EXTRACT_MASTER_KEYS';
export const CW_EXTRACT_SESSION_KEYS = 'CW_EXTRACT_SESSION_KEYS';
export const CW_GENERATE_EPHEMERAL_KEY_PAIR = 'CW_GENERATE_EPHEMERAL_KEY_PAIR';
export const CW_GET_EXTERNAL_PUBLIC_KEY = 'CW_GET_EXTERNAL_PUBLIC_KEY';
export const CW_QR_AUTH_GET = 'CW_QR_AUTH_GET';
export const CW_QR_AUTH_RESET = 'CW_QR_AUTH_RESET';
export const CW_QR_AUTH_SET = 'CW_QR_AUTH_SET';
export const CW_RESET_KEYS = 'CW_RESET_KEYS';
export const CW_SET_SESSION_KEYS = 'CW_SET_SESSION_KEYS';

export const __CREDENTIAL_SKIP_CRYPTO_ON_KEYS__ = ['domain', 'groupId', 'id', 'shared', 'publicKey', 'secretKey', 'sharedKey', 'sharedByUserName', 'dashboardSpaceId','invitationId', 'accepted'];
export const __MOCK_PK__ = 'mM1sNffsJzov10USBsD5rRzEvKg2HGL38OttzpyMdFk=';
export const __MOCK_SK__ = 'JSqxKC8Gb0acunQyiKKJzJT20Mk38F+VlyaeeHqpP3I=';
